import React from 'react';

const SkipNavigation = () => {
  return (
    <div className="sr-only focus:not-sr-only">
      <a
        href="#main-content"
        className="absolute top-0 left-0 z-[100] bg-primary text-primary-foreground px-4 py-2 text-sm font-medium rounded-br-md shadow-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all duration-200"
      >
        Pular para o conteúdo principal
      </a>
      <a
        href="#produtos"
        className="absolute top-0 left-32 z-[100] bg-primary text-primary-foreground px-4 py-2 text-sm font-medium rounded-br-md shadow-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all duration-200"
      >
        Ir para produtos
      </a>
      <a
        href="#atendimento"
        className="absolute top-0 left-56 z-[100] bg-primary text-primary-foreground px-4 py-2 text-sm font-medium rounded-br-md shadow-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all duration-200"
      >
        Ir para atendimento
      </a>
    </div>
  );
};

export default SkipNavigation;